import { useTranslation } from 'react-i18next'
import { AddEmployee } from '~/features/common/Taxipark/Employees/AddEmployee'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'employees', link: '/taxipark/employees' },
  { titleI18n: 'create employee' },
]

export const AddEmployeePage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('create employee')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create employee')}</PageTitle>
      </Container>
      <AddEmployee />
    </PageContainer>
  )
}
